import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Table, Input, Button, Space } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import offerService from "../../../../api/Offer/OfferService";
export default class PreviewAllOffers extends Component {
  constructor(props) {
    super(props);

    this.state = { offerList: [] };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getOfferList();
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  onButtonClick = (id) => {
    offerService.deleteOffer(id);
    toast.success(`Offer Deleted Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getOfferList();
  };

  getOfferList = () => {
    let offerList = this.state.offerList;
    offerService
      .getAllOffers()
      .then((res) => {
        offerList = res.data;
        this.setState({ offerList });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };
  componentWillUnmount() { }

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() { }

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  render() {
    let data =
      this.state.offerList != null
        ? this.state.offerList
          .sort((a, b) => a.createdAt > b.createdAt)
          .map((offer, i) => {
            return {
              index: i + 1,
              img: <img src={offer.img_path} width="100%" />,
              name: offer.title,
              description: offer.description,
              cat:
                offer.categories.name != null
                  ? offer.categories.name
                  : "",
              rating: offer.rating === null ? "0/5" : offer.rating + "/5",
              action: (
                <Button
                  className="btn btn-danger text-white"
                  onClick={() => this.onButtonClick(offer.id)}
                >
                  Delete
                </Button>
              ),
            };
          })
        : null;

    const columns = [
      {
        title: "#",
        dataIndex: "index",
        key: "index",
      },
      {
        title: "Image",
        dataIndex: "img",
        key: "img",
      },
      {
        title: "Offer Title",
        dataIndex: "name",
        key: "name",
        ...this.getColumnSearchProps("name"),
      },
      {
        title: "Offer Description",
        dataIndex: "description",
        key: "description",
        ...this.getColumnSearchProps("description"),
      },
      {
        title: "Category Name",
        dataIndex: "cat",
        key: "cat",
        ...this.getColumnSearchProps("cat"),
      },
      {
        title: "Offer Rating",
        dataIndex: "rating",
        key: "rating",
        ...this.getColumnSearchProps("rating"),
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
      },
    ];
    return (
      <>
        <h5 className="m-0">Offers</h5>
        <Row form>
          <Col md="12" className="form-group  mt-4">
            <Table
              columns={columns}
              dataSource={data !== null ? data : null}
              className="p-0 m-0"
              pagination={{ pageSize: 5, position: ["bottomCenter"] }}
              style={{ textAlign: "center" }}
            />
          </Col>
        </Row>
      </>
    );
  }
}
